import { render, staticRenderFns } from "./ObjectSkillTypeDeleteConfirmationDialog.vue?vue&type=template&id=3ab8a0b2"
import script from "./ObjectSkillTypeDeleteConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ObjectSkillTypeDeleteConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports